import RadialChart from "@/src/components/CommonCharts/RadialChart";
import styles from "../Stats.module.css";
import {
  HUD_STATS_PROP_LBL_CLR_MAP,
  RADIAL_CHART_FULL_CONFIG,
} from "@/src/constants/StatsCornerConstants";

export const BetDetails = ({ hudStatsRadialBarArr2, hudStats }) => {
  if (!hudStats || Object.keys(hudStats).length === 0) return null;
  return (
    <div
      className={`flex justify-between ${styles.coreCardConfig} pt-2 pb-7.25 px-3 mt-3`}
    >
      {hudStatsRadialBarArr2.map(
        (item) =>
          hudStats.hasOwnProperty(item) &&
          !isNaN(Number(hudStats?.[item])) && (
            <div className="h-20 flex-1">
              <RadialChart
                dataObj={{ [item]: hudStats?.[item] }}
                chartProps={RADIAL_CHART_FULL_CONFIG}
                hasLegend={true}
                coreMap={HUD_STATS_PROP_LBL_CLR_MAP}
              />
            </div>
          )
      )}
    </div>
  );
};
